
import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/redux';
import { setCardTimeProgress } from '../MedExamsSlice';
import { useEffect, useRef, useState } from 'react';
import { LinearProgress, LinearProgressProps, linearProgressClasses, styled } from '@mui/material';
import { ModalNames } from '../../../slices/AppSlice';

function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number },
)

{
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${Math.round(props.value)/5}`}</Typography>
      </Box>
    </Box>
  );
}


const linearProgressStyle = {
  width: '256px',
  height: '48px',

  "&.MuiLinearProgress-root": {
    borderRadius: '4px',
    transition: '0.2s'
  },

  "&.MuiLinearProgress-colorPrimary": {
    backgroundColor: '#E0F5FD',
    transition: '0.2s'
  },
  "& .MuiLinearProgress-barColorPrimary": {
    borderRadius: '4px',
    backgroundColor: '#4BB7DF',
    transition: '0.2s'
  },

  '&.MuiLinearProgress-colorError': {
    backgroundColor: '#FFCFCF',
    transition: '0.2s'
  },
  '& .MuiLinearProgress-barColorError': {
    borderRadius: '4px',
    backgroundColor: '#FF6F6F',
    transition: '0.2s'
  },
}

const typographyStyle = {
  '&.MuiTypography-root': {
    FontFamily: 'Roboto',
    fontWeight: '900',
    fontSize: '32px',
    lineHeight: '37px',
    transition: '0.2s'
  },
}

function LinearProgressWithLabel(props: LinearProgressProps & 
  { value: number, progressUnit: number, color: string }
) {
  const t = { m: Math.floor((props.value/60) % 60), s: Math.floor(props.value % 60) }
  const clockFace = {
    m: (t.m.toString().length > 1 ? t.m.toString() : '0' + t.m),
    s: (t.s.toString().length > 1 ? t.s.toString() : '0' + t.s),
  }
  const progress = props.value * props.progressUnit

  return (
    <Box>
      <Box 
        sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative'}}>
        <Box>
          <LinearProgress variant="determinate" 
            sx={linearProgressStyle} 
            color={props.color}
            value={progress <= 100 ? progress : 100} 
          />
        </Box>
        <Box sx={{ position: 'absolute' }}>
          <Typography sx={{...typographyStyle, color: props.color==='error'?'#940002':'#00506E'}}>
            {clockFace.m}:{clockFace.s}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export const TimeProgressBar=(props: any)=> {
  const dispatch = useAppDispatch();
  const { currentCardTimeProgress, card, identCard } = useAppSelector(state => state.examReducer)
  const { currentModal } = useAppSelector(state => state.appReducer)
  const [showRing, setShowRing] = useState<boolean>(false)
  const { resetMedCard, isPenalty } = props

  const sound = new Audio(require('../assets/audio/budilnik.mp3'))

  const timerRef = useRef<any>()
  useEffect(() => {
    timerRef.current = setInterval(() => {
      if(card === null && identCard === null) {
        setCardTimeProgress(0)
        clearInterval(timerRef.current)
      } else {
        dispatch(setCardTimeProgress(currentCardTimeProgress+1))
      }
      if (currentCardTimeProgress === 50) { setShowRing(true); sound.play(); }
      if (currentCardTimeProgress === 55) { setShowRing(false) }
      if (currentCardTimeProgress === 60) { resetMedCard(); clearInterval(timerRef.current) }
      if (currentModal === ModalNames.ECP_SIGNING || isPenalty) { clearInterval(timerRef.current) }
    }, 1000);
    return () => {
      clearInterval(timerRef.current);
    };
  }, [card, identCard, currentCardTimeProgress, currentModal, isPenalty]);

  useEffect(() => {
    if (currentModal === ModalNames.ECP_SIGNING) {
      clearInterval(timerRef.current)
    }
  }, [currentModal])

  return (
    <Box
      sx={{display: 'flex', gap: '24px', alignItems: 'center'}}
    >
      { showRing && 
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5406 3.21457C7.70903 3.05763 7.84412 2.86837 7.93781 2.65809C8.03151 2.4478 8.08189 2.2208 8.08595 1.99062C8.09001 1.76044 8.04767 1.53181 7.96145 1.31835C7.87523 1.10489 7.7469 0.910982 7.58412 0.748196C7.42133 0.585411 7.22742 0.45708 7.01397 0.370861C6.80051 0.284641 6.57187 0.242299 6.34169 0.246361C6.11151 0.250422 5.88451 0.300803 5.67423 0.394499C5.46394 0.488195 5.27468 0.623286 5.11774 0.791713C3.16566 2.7422 1.77385 5.18162 1.08803 7.85457C0.97497 8.29498 1.04149 8.76227 1.27297 9.15363C1.50444 9.54499 1.8819 9.82837 2.32231 9.94143C2.76272 10.0545 3.23001 9.98796 3.62137 9.75649C4.01273 9.52501 4.29611 9.14755 4.40917 8.70714C4.93717 6.64543 6.00917 4.74371 7.5406 3.21457ZM26.8846 0.791713C26.5596 0.488901 26.1298 0.324048 25.6857 0.331884C25.2416 0.33972 24.8178 0.519633 24.5037 0.83372C24.1897 1.14781 24.0097 1.57154 24.0019 2.01566C23.9941 2.45978 24.1589 2.8896 24.4617 3.21457C25.9775 4.7321 27.0574 6.62913 27.5886 8.70714C27.642 8.92785 27.7386 9.13576 27.873 9.31879C28.0074 9.50183 28.1768 9.65635 28.3713 9.77338C28.5659 9.89041 28.7818 9.96762 29.0065 10.0005C29.2311 10.0334 29.4601 10.0214 29.6801 9.96506C29.9 9.90874 30.1066 9.80928 30.2878 9.67247C30.4691 9.53565 30.6213 9.36419 30.7357 9.16805C30.8501 8.97192 30.9244 8.75501 30.9543 8.52992C30.9841 8.30483 30.969 8.07605 30.9097 7.85686C30.2259 5.1828 28.8356 2.74179 26.8846 0.789427V0.791713ZM13.3943 27.6717C13.177 27.5975 12.9423 27.5904 12.7209 27.6515C12.4995 27.7125 12.3016 27.8389 12.1531 28.0141C12.0046 28.1893 11.9123 28.4051 11.8882 28.6335C11.8642 28.8619 11.9095 29.0923 12.0183 29.2946C12.4087 30.0243 12.9898 30.6343 13.6997 31.0596C14.4096 31.4849 15.2216 31.7096 16.0492 31.7096C16.8767 31.7096 17.6888 31.4849 18.3986 31.0596C19.1085 30.6343 19.6897 30.0243 20.08 29.2946C20.1885 29.0925 20.2336 28.8625 20.2096 28.6344C20.1856 28.4064 20.0935 28.1908 19.9453 28.0158C19.7972 27.8407 19.5998 27.7143 19.3788 27.6529C19.1578 27.5916 18.9235 27.5981 18.7063 27.6717C18.1257 27.8683 17.2709 28.0191 16.0503 28.0191C14.8297 28.0191 13.9726 27.8683 13.3943 27.6717Z" fill="#3E3E3E"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0455 2.56641C13.6303 2.56641 11.3141 3.52582 9.60634 5.23358C7.89858 6.94134 6.93917 9.25756 6.93917 11.6727C6.93917 13.259 6.67631 14.4841 6.30374 15.4258C6.18946 15.7138 5.9426 15.9675 5.42374 16.3081L5.03288 16.5527C4.59403 16.8201 4.02717 17.1675 3.58831 17.5561C2.62831 18.4087 2.30831 19.6133 2.39288 20.6875C2.47746 21.7298 2.96203 22.8133 3.84888 23.4807C3.90795 23.5285 3.96977 23.5727 4.03403 23.6133C4.14831 23.6864 4.30603 23.7755 4.51403 23.8738C4.92546 24.0727 5.5426 24.3081 6.44317 24.5367C8.24431 24.9938 11.2203 25.4235 16.0477 25.4235C20.8752 25.4235 23.8489 24.9915 25.65 24.5367C26.5529 24.3081 27.17 24.0727 27.5815 23.8738C27.7983 23.7708 28.0062 23.65 28.2032 23.5127L28.2466 23.4807C29.1335 22.8133 29.618 21.7298 29.7003 20.6853C29.7872 19.6155 29.4649 18.4087 28.5072 17.5538C28.0683 17.1653 27.5015 16.8201 27.0626 16.5527C26.9311 16.4731 26.8008 16.3916 26.6717 16.3081C26.1529 15.9675 25.906 15.7138 25.7895 15.4258C25.7289 15.2722 25.6732 15.1167 25.6226 14.9595C25.3269 13.8884 25.1694 12.7838 25.154 11.6727C25.154 9.25756 24.1946 6.94134 22.4869 5.23358C20.7791 3.52582 18.4629 2.56641 16.0477 2.56641H16.0455Z" fill="#2A2A2A"/>
        </svg>
      }
      <LinearProgressWithLabel 
        value={currentCardTimeProgress} 
        progressUnit={5}
        color={currentCardTimeProgress <= 50 ? 'primary' : 'error'}
      />
    </Box>
  );
}